import { useEffect, useState } from 'react';

import { Box, Flex } from '@chakra-ui/react';
import LaunchdeckButton from '../../global/components/helper-components/components/LaunchdeckButton';
import { MdEmail } from "react-icons/md";
import LaunchdeckFormInput from '../../forms/TextInputField/components/LaunchdeckFormInput';
import LaunchdeckFormTextAreaInput from '../../forms/TextInputField/components/LaunchdeckFormTextAreaInput';
import { FaUser } from 'react-icons/fa6';

export default function DsrRequestInviteForm({ handleRequestInvite, requestUserEmail, requestUsername }) {

	const [lockUsername, setLockUsername] = useState(false)
	const [requestMessageInput, setRequestMessageInput] = useState('');
	const [requestUserNameInput, setRequestUserNameInput] = useState("");
	const [showMessageInputError, setShowMessageInputError] = useState(false);
	const [showNameInputError, setShowNameInputError] = useState(false);

	useEffect(() => {
		if (requestUsername) {
			setLockUsername(true)
			setRequestUserNameInput(requestUsername)
		}
	}, [requestUsername]);

	//Function
	const handleButtonClick = () => {
		if (requestMessageInput && requestUserNameInput) {
			handleRequestInvite(requestMessageInput, requestUserNameInput)
		} else {
			if (!requestMessageInput) setShowMessageInputError(true)
			if (!requestUserNameInput) setShowNameInputError(true)

		}
	}

	const onChangeHandler = (event) => {
		setShowMessageInputError(false)

		switch (event.target.name) {
			case ('request-message'): {
				setShowMessageInputError(false)
				setRequestMessageInput(event.target.value)
				break;
			}
			case ('request-user-name'): {
				setShowNameInputError(false)
				setRequestUserNameInput(event.target.value)
				break;
			}
			default: {
				break;
			}
		}
	};


	return (
		<Box w="100%" align="center">

			<Flex direction='column' align='center' w='100%' gap='1em' maxW='30em'>
				{lockUsername ?
					<Flex direction='column' my='1em' gap='0.5em' w='100%'>

						<Box w='100%' bg='gray.100' color='brandDark.500' rounded='0.25em' p='0.5em 1em' >
							<Flex w='100%' justify='flex-start' align='center' fontSize='0.8em'>
								<Box as={FaUser} boxSize="1em" mr='1em' />
								<Box>{requestUserNameInput}</Box>
							</Flex>
						</Box>

						<Box w='100%' mt='0.25em' bg='gray.100' color='brandDark.500' rounded='0.25em' p='0.5em 1em' >
							<Flex w='100%' justify='flex-start' align='center' fontSize='0.8em'>
								<Box as={MdEmail} boxSize="1em" mr='1em' />
								<Box>{requestUserEmail}</Box>
							</Flex>
						</Box>

					</Flex>
					:
					<Box mt='1em' w='100%'>
						<LaunchdeckFormInput
							label='Your name'
							name={'request-user-name'}
							onChange={onChangeHandler}
							value={requestUserNameInput}
							placeholder={'John Doe'}
							isRequired={true}
							// isDisabled={contactLaunchdeckInProgress}

							errorLogic={showNameInputError}
							errorMessage={'Room administrators require this information to know who they are granting entry to'}
						/>

					</Box>
				}

				<LaunchdeckFormTextAreaInput
					label='Note to admin'
					name={'request-message'}
					onChange={onChangeHandler}

					value={requestMessageInput}
					placeholder={`Let them know why you'd like to join the room`}
					charLimit={300}

					errorLogic={showMessageInputError}
					errorMessage={'A short message will help them act more quickly'}
				/>
			</Flex>

			<Flex w='100%' mt='2em' py='0.625em'>
				<Flex justify='center' w='100%'>
					<LaunchdeckButton bg='brand.500' color='gray.50' w='100%' label='Send request' onClick={() => handleButtonClick()} />
				</Flex>
			</Flex>
		</Box>
	);
};

